import { render, staticRenderFns } from "./TambahArsip.vue?vue&type=template&id=32058cc1&"
import script from "./TambahArsip.vue?vue&type=script&lang=js&"
export * from "./TambahArsip.vue?vue&type=script&lang=js&"
import style0 from "./TambahArsip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports